var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDinersClubLight = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 32 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  fill: "#0069aa",
  rx: 4
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0069aa",
  fillRule: "evenodd",
  d: "M7.08 12.14a7.72 7.72 0 1 1 15.45 0 7.72 7.72 0 0 1-15.45 0",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M19.48 11.99a4.65 4.65 0 0 0-2.99-4.34v8.67a4.65 4.65 0 0 0 2.99-4.33m-6.31 4.33V7.65a4.65 4.65 0 0 0 0 8.67m1.66-11.66a7.32 7.32 0 1 0 0 14.65 7.32 7.32 0 0 0 0-14.65M14.81 20a8.02 8.02 0 0 1-8.06-7.93A7.9 7.9 0 0 1 14.8 4h2.08c4.37 0 8.36 3.3 8.36 8.07 0 4.36-3.99 7.93-8.36 7.93H14.8Z",
  clipRule: "evenodd"
})));
export default SvgDinersClubLight;